<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    <defs>
        <polygon id="triangle"
                 points="0 0, 100 50, 0 100"/>
    </defs>

    @for (line of board; track $index; let y = $index) {
        <g>
            @for (c of line; track $index; let x = $index) {
                <g>
                    <circle id="click-{{ x }}-{{ y }}"
                            (click)="onBoardClick(x, y)"
                            [attr.r]="0.45 * SPACE_SIZE"
                            [attr.cx]="(x + 0.5) * SPACE_SIZE"
                            [attr.cy]="(y + 0.5) * SPACE_SIZE"
                            [ngClass]="getPieceClasses(x, y)"
                            class="base"/>
                </g>
            }
        </g>
    }
    @if (chosenCoord.isPresent()) {
        <g>
            @for (direction of getPossiblesDirections(); track direction.toString()) {
                <use xlink:href="#triangle"
                     id="choose-direction-{{ direction }}"
                     (click)="chooseDirection(direction)"
                     [attr.transform]="getQuixoArrowTransform(direction)"
                     class="semi-transparent"/>
            }
        </g>
    }
</svg>
